import React, { useState } from 'react'
import Button from '@mui/material/Button'
import axios from 'axios'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useNavigate, Link } from 'react-router-dom'
import Container from '@mui/material/Container'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'

export const InfoRegUser = () => {
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState(false)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordError, setPasswordError] = useState(false)
  const [retypePassword, setRetypePassword] = useState('')
  const [retypePasswordError, setRetypePasswordError] = useState(false)

  // Rozdzielenie numeru na kod kraju i właściwy numer
  const [countryCode, setCountryCode] = useState('+48')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneNumberError, setPhoneNumberError] = useState(false)

  const [showPassword, setShowPassword] = useState(false)
  const order_id = localStorage.getItem('auth_orderId')

  const navigate = useNavigate()

  const handleInputChange = event => {
    const { name, value } = event.target
    switch (name) {
      case 'name':
        setName(value)
        setNameError(false)
        break
      case 'email':
        setEmail(value)
        setEmailError(false)
        break
      case 'password':
        setPassword(value)
        setPasswordError(false)
        break
      case 'retypePassword':
        setRetypePassword(value)
        setRetypePasswordError(false)
        break
      case 'phoneNumber':
        setPhoneNumber(value)
        setPhoneNumberError(false)
        break
      default:
        break
    }
  }

  const handleCountryCodeChange = event => {
    setCountryCode(event.target.value)
    setPhoneNumberError(false)
  }

  const handleTogglePasswordVisibility = () => {
    setShowPassword(prev => !prev)
  }

  const handleNext = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      setEmailError(true)
      return
    }

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d).+$/
    if (!passwordRegex.test(password)) {
      setPasswordError(true)
      return
    }

    if (password !== retypePassword) {
      setRetypePasswordError(true)
      return
    }

    // Łączenie wybranego kodu kraju z numerem telefonu
    const fullPhoneNumber = countryCode + phoneNumber
    // Przykładowa walidacja: oczekujemy 9 cyfr po kodzie kraju
    const phoneRegex = new RegExp(`^\\${countryCode}\\d{9}$`)
    if (!phoneRegex.test(fullPhoneNumber)) {
      setPhoneNumberError(true)
      return
    }

    try {
      const requestData = {
        phone: fullPhoneNumber,
        name,
        email,
        order_id,
        password
      }

      console.log('Wysyłanie danych rejestracyjnych:', requestData)

      const registrationResponse = await axios.post(
        process.env.REACT_APP_API_URL + '/loyalty/register-user',
        requestData
      )

      console.log('Odpowiedź serwera po rejestracji:', registrationResponse.data)
    } catch (error) {
      console.error('Błąd:', error)
      return
    }

    try {
      navigate(`/accept/${fullPhoneNumber}`)
    } catch (error) {
      console.error('Błąd:', error)
    }
  }

  return (
    <Container maxWidth='lg'>
      <Grid container spacing={2} alignItems='center' justifyContent='center' style={{ minHeight: '50px' }}></Grid>
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={2} sm={2}></Grid>
        <Grid item xs={8} sm={8}>
          <TextField
            name='name'
            label='Imię i nazwisko'
            variant='outlined'
            value={name}
            onChange={handleInputChange}
            fullWidth
            margin='normal'
            error={nameError}
          />

          <TextField
            name='email'
            label='Email'
            variant='outlined'
            value={email}
            onChange={handleInputChange}
            fullWidth
            margin='normal'
            error={emailError}
          />

          <TextField
            name='password'
            label='Hasło'
            type={showPassword ? 'text' : 'password'}
            variant='outlined'
            value={password}
            onChange={handleInputChange}
            fullWidth
            margin='normal'
            error={passwordError}
            helperText='Hasło musi zawierać co najmniej jedną wielką literę i jedną cyfrę.'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={handleTogglePasswordVisibility} edge='end'>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            name='retypePassword'
            label='Powtórz hasło'
            type={showPassword ? 'text' : 'password'}
            variant='outlined'
            value={retypePassword}
            onChange={handleInputChange}
            fullWidth
            margin='normal'
            error={retypePasswordError}
            helperText={retypePasswordError ? 'Hasła nie są identyczne.' : ''}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={handleTogglePasswordVisibility} edge='end'>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Grid container spacing={1} alignItems='flex-end' style={{ marginTop: '16px' }}>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id='country-code-label'>Kod kraju</InputLabel>
                <Select
                  labelId='country-code-label'
                  name='countryCode'
                  value={countryCode}
                  label='Kod kraju'
                  onChange={handleCountryCodeChange}
                >
                  <MenuItem value='+48'>+48 (Polska)</MenuItem>
                  <MenuItem value='+420'>+420 (Czechy)</MenuItem>
                  <MenuItem value='+380'>+380 (Ukraina)</MenuItem>
                  <MenuItem value='+1'>+1 (USA)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <TextField
                name='phoneNumber'
                label='Numer telefonu'
                variant='outlined'
                value={phoneNumber}
                onChange={handleInputChange}
                fullWidth
                error={phoneNumberError}
                helperText={phoneNumberError ? 'Wprowadź poprawny numer telefonu' : ''}
              />
            </Grid>
          </Grid>

          <Grid container justifyContent='center' style={{ marginTop: '16px' }}>
            <Button
              onClick={handleNext}
              variant='contained'
              style={{
                backgroundColor: '#3FC500',
                borderRadius: '15px',
                width: '164px',
                color: '#fff',
                fontFamily: 'Poppins',
                fontSize: '20px',
                fontStyle: 'normal',
                fontWeight: '700',
                boxShadow: 'none'
              }}
            >
              Dalej
            </Button>
          </Grid>
          <Link to='/login'>
            <button
              style={{
                border: 'none',
                color: '#00A3FF',
                backgroundColor: 'transparent',
                marginTop: '15px',
                fontFamily: 'Poppins'
              }}
            >
              Jeśli masz konto, kliknij tutaj
            </button>
          </Link>
        </Grid>
        <Grid item xs={2} sm={2}></Grid>
      </Grid>
    </Container>
  )
}

export const InputPhoneNumber = () => {
  return (
    <>
      <InfoRegUser />
    </>
  )
}
